// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hideOnSubmit {
    display: none;
}
.showOnSubmit {
    display: block;
}`, "",{"version":3,"sources":["webpack://./src/components/ai-assistant/ai-assistant.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;AACA;IACI,cAAc;AAClB","sourcesContent":[".hideOnSubmit {\n    display: none;\n}\n.showOnSubmit {\n    display: block;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
